import getDurationString from '../../../services/getDurationString';
import { FunctionComponent } from 'react';
import { ClockRegularIcon } from '../../Icons/ClockRegularIcon';
import styles from '../styles.module.scss';
import { PublicCourse } from '@cademy-package/sdk-component-types';

export const getRequestDurationText = (duration_pricing: PublicCourse['duration_pricing']) => {
    if (!duration_pricing || !duration_pricing.length) return 'To be confirmed';
    if (duration_pricing.length === 1) return getDurationString(duration_pricing[0].duration * 60);
    return `From ${getDurationString(duration_pricing[0].duration * 60)} to ${getDurationString(duration_pricing[duration_pricing.length - 1].duration * 60)}`;
};

export const RequestDurationHighlight: FunctionComponent<{ course: PublicCourse }> = ({
    course,
}) => {
    if (!course.duration_pricing || course.type !== 'on-request') {
        return null;
    }

    const durationPricingText = getRequestDurationText(course.duration_pricing);

    return (
        <li className={styles.highlight}>
            <span className={styles.icon}>
                <ClockRegularIcon />
            </span>
            <p>{durationPricingText}</p>
        </li>
    );
};
